import type { FC } from 'react';
import { Link } from 'react-router-dom';

import { PersonDefault } from '@shared/assets';

import type { DialogUser } from '../../lib';
import * as st from './styles.module.scss';

interface Props {
	user: DialogUser;
}

export const UserCard: FC<Props> = ({ user }) => {
	return (
		<div>
			<Link to="">
				<div className={st.card}>
					<div className={st.img}>{user.image ? <img src={user.image} /> : <PersonDefault />}</div>
					<div className={st.title}>{`${user.lastName} ${user.firstName}`}</div>
				</div>
			</Link>
		</div>
	);
};
